var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-base', {
    attrs: {
      "showFooter": false,
      "displayDivider": true,
      "headerLogo": _vm.logoUrl,
      "isFillHeight": _vm.isFillHeight
    }
  }, [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }